import { GET_SITES_QUERY } from '~/queries/wpQueries';
import { DEFAULT_URL } from './constants';
import { gqlFetch } from './gqlFetch';

export function getTeamEndpoint(slug?: string) {
  return slug ? `${DEFAULT_URL}/${slug}/graphql` : undefined;
}

export async function getTeam(slug?: string) {
  if (!slug) return;

  const { data } = await gqlFetch({
    query: GET_SITES_QUERY,
    cache: 'force-cache',
  });
  const endpoints =
    data?.sites.map(({ path }: { path: string }) => path.replaceAll('/', '')) ||
    [];

  const team = endpoints.includes(slug) ? slug : undefined;

  return team;
}

export async function getTeams(): Promise<string[]> {
  const {
    data: { sites },
  } = await gqlFetch({
    query: GET_SITES_QUERY,
    cache: 'force-cache',
  });
  const teams = sites
    .map(({ path }: { path: string }) => path.replaceAll('/', ''))
    .filter(Boolean);

  return teams;
}
